export default class Metrics {
  totalInvested: number;
  totalFunded: number;
  registeredInvestors: number;

  constructor(entity: Metrics) {
    this.totalInvested = entity.totalInvested;
    this.totalFunded = entity.totalFunded;
    this.registeredInvestors = entity.registeredInvestors;
  }
}



// WEBPACK FOOTER //
// ./src/entities/Metrics.tsx